import api from "../utils/axios";

const baseUrl = `/api/localStorages/`;

export function get(key) {
  return api.get(`${baseUrl}${key}`);
}

export function save(localStorage) {
  return api.post(baseUrl, localStorage);
}

export function remove(id) {
  return api.delete(`${baseUrl}${id}`);
}
